import React from "react";

export default function RightArrow() {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.16 8.22524C14.1022 8.22524 14.0443 8.22524 13.982 8.22524C9.91816 8.22524 5.85433 8.22524 1.79495 8.22524C1.34539 8.22524 1.06497 7.97354 1.00711 7.52048C0.949247 7.09259 1.24302 6.66974 1.62581 6.62947C1.70148 6.6194 1.7816 6.62443 1.85727 6.62443C5.89884 6.62443 9.94042 6.62443 13.982 6.62443C14.0399 6.62443 14.1022 6.62443 14.1778 6.62443C14.1556 6.53886 14.1066 6.50362 14.0666 6.45831C12.8826 5.11927 11.6986 3.7752 10.5102 2.43617C10.3143 2.21467 10.2119 1.968 10.2653 1.6559C10.3188 1.34883 10.4834 1.1374 10.7505 1.04175C11.0087 0.951142 11.2446 1.01155 11.4449 1.21794C11.4805 1.25318 11.5161 1.29849 11.5517 1.33876C13.1407 3.15099 14.7387 4.95315 16.3366 6.76035C16.7328 7.20838 16.7328 7.63626 16.3411 8.07925C14.7253 9.90659 13.1051 11.7339 11.4894 13.5663C11.2757 13.8079 11.0354 13.9237 10.7372 13.823C10.252 13.667 10.065 12.9924 10.3855 12.5494C10.4345 12.484 10.4923 12.4185 10.5458 12.3581C11.7119 11.0443 12.8781 9.7304 14.0443 8.4115C14.0888 8.36116 14.1422 8.32592 14.1867 8.28565C14.1778 8.26551 14.1689 8.24537 14.16 8.22524Z"
        fill="#002046"
        stroke="#002046"
        stroke-width="0.5"
      />
    </svg>
  );
}
